import React, { createContext, useContext, useState } from "react";
import RewardOverlay from "./RewardOverlay";

const RewardContext = createContext();

export const RewardProvider = ({ children }) => {
  const [rewardId, setRewardId] = useState(0);
  const [rewardVisible, setRewardVisible] = useState(false);

  const showReward = () => {
    setRewardId(id => id + 1);
    setRewardVisible(true);
  };

  return (
    <RewardContext.Provider value={{ showReward }}>
      {children}
      <RewardOverlay
        key={rewardId}
        visible={rewardVisible}
        onHide={() => setRewardVisible(false)}
      />
    </RewardContext.Provider>
  );
};

export const useReward = () => {
  const ctx = useContext(RewardContext);
  if (!ctx) {
    throw new Error("useReward must be used within RewardProvider");
  }
  return ctx;
};
